import React, { useState } from "react";
import PropTypes from "prop-types";
import { useLazyQuery } from "@apollo/client";
import Checkbox from "./Checkbox";
import "./BrandFilter.css";
import { gql } from "@apollo/client";

const SEARCH_BRANDS = gql`
  query SearchBrands($query: String!, $offset: Int!, $limit: Int!) {
    searchBrands(query: $query, offset: $offset, limit: $limit) {
      id
      name
      name_kr
    }
  }
`;

const BrandFilter = ({ selectedBrands, onChange }) => {
  const [brandQuery, setBrandQuery] = useState("");
  const [brandResults, setBrandResults] = useState([]);

  const [searchBrands] = useLazyQuery(SEARCH_BRANDS, {
    onCompleted: (data) => {
      if (data && data.searchBrands) {
        setBrandResults(data.searchBrands);
      }
    },
  });

  const handleQueryChange = (e) => {
    const query = e.target.value;
    setBrandQuery(query);
    if (query.length >= 1) {
      searchBrands({ variables: { query, offset: 0, limit: 5 } });
    } else {
      setBrandResults([]);
    }
  };

  const isSelected = (brand) =>
    selectedBrands.some((b) =>
      typeof b === "string" ? b === brand.name : b.id === brand.id,
    );

  const handleToggle = (brandObj) => {
    let newSelection;
    if (isSelected(brandObj)) {
      newSelection = selectedBrands.filter((b) =>
        typeof b === "string" ? b !== brandObj.name : b.id !== brandObj.id,
      );
    } else {
      newSelection = [...selectedBrands, brandObj];
    }
    onChange(newSelection);
  };

  return (
    <div className="brand-filter-container">
      <input
        type="text"
        placeholder="검색"
        value={brandQuery}
        onChange={handleQueryChange}
        className="brand-search-input"
      />

      {brandResults.map((brand) => (
        <div key={brand.id} className="brand-item">
          <Checkbox
            id={`brand-${brand.id}`}
            text={brand.name}
            subText={brand.name_kr}
            checked={isSelected(brand)}
            onChange={() => handleToggle(brand)}
          />
        </div>
      ))}
    </div>
  );
};

BrandFilter.propTypes = {
  selectedBrands: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default BrandFilter;
